import script from "./video-template.vue?vue&type=script&lang=ts&setup=true"
export * from "./video-template.vue?vue&type=script&lang=ts&setup=true"

import "./video-template.vue?vue&type=style&index=0&id=7d24c690&lang=scss"

const __exports__ = script;

export default __exports__